import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services';
import { APIRoutes } from '@constants';
import {
  AliasAvailability,
  ClientsPaginated,
  PartnerClientAlias,
} from '@interfaces';
import { PaginationPayload } from '@interfaces';
import { Client } from '@models';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  private readonly aliasesUrl = APIRoutes.CLIENTS_ALIASES;

  constructor(private apiService: ApiService) {}

  public getClients(params: PaginationPayload): Observable<ClientsPaginated> {
    return this.apiService.get<ClientsPaginated>(this.aliasesUrl, {
      params: { Page: params.page, PageSize: params.perPage },
    });
  }

  public getClientById(id: string): Observable<Client> {
    return this.apiService.get<Client>(`Clients/${id}/aliases/detail`);
  }

  public checkAliasAvailability(alias: string): Observable<AliasAvailability> {
    return this.apiService.get<AliasAvailability>(
      'Clients/aliases/availability',
      {
        params: { Alias: alias },
      },
    );
  }

  public getClientAliases(clientId: string): Observable<PartnerClientAlias> {
    return this.apiService.get<PartnerClientAlias>(
      `Clients/${clientId}/aliases`,
    );
  }

  public putClientAlias(clientId: string, alias: string): Observable<void> {
    return this.apiService.put<void, { alias: string }>(
      `Clients/${clientId}/aliases`,
      { alias },
    );
  }
}
